import { useAuthContext } from '@/context/AuthContext';
import { Label } from "../atoms/texts/label"
import { Button } from "../molecules/buttons/button"
import { Popover, PopoverContent, PopoverTrigger } from "../molecules/popover"
import Translate from "./Translate"
import { useNavigate } from "react-router-dom";
import { Switch } from "../ui/SwitchForAccountSelection";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {useAppSelector} from '@/store/hooks.js';



export default function PopUpProfile({ component, isForMobile = false }) {

    const navigate = useNavigate();
    // console.log('user : ', user)
    const { hasPrivileges, viewAs, handleSetViewAs } = useAuthContext();
    const user = useAppSelector((state) => state.auth.currentUser);
    const [open, setOpen] = useState(false);

    const { i18n } = useTranslation("global");

    useEffect(() => {
        i18n.changeLanguage(user.language.toLowerCase())
    }, [user.language]);

    return (

        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                {component}
            </PopoverTrigger>
            <PopoverContent className={`mr-3 items-end flex flex-col gap-firstDegree p-secondDegree shadow-md  overflow-hidden bg-white w-max rounded-md ${isForMobile && ` rounded-sm shadow-3xl absolute left-[50vw] -translate-x-1/2 top-[50vh] transform -translate-y-1/2`}`}>
                <span>
                    <Label message="global.popUpProfile.hi" />
                    <Label fontWeight="bold" >{user.firstname} {user.lastname}</Label>
                </span>
                <span className="text-end">
                    <Label message="global.popUpProfile.role" />
                    {hasPrivileges('ADMIN_') && <Label fontWeight="bold" message="role.admin" />}
                    {hasPrivileges('ADMIN_') && hasPrivileges('USER_') && <Label message="role.both" />}
                    {hasPrivileges('USER_') && <Label fontWeight="bold" message="role.consultant" />}
                </span>
                {
                    hasPrivileges('ADMIN_') && hasPrivileges('USER_') &&
                    <div className="justify-end items-center flex flex-row gap-firstDegree bg-lighter flex-nowrap p-secondDegree rounded-sm border border-medium w-full">
                        <Label fontWeight="bold" message="role.area"></Label>
                        <div className="flex items-center gap-firstDegree">
                            <Label fontWeight={viewAs == "ADMIN_" && `bold`} className={viewAs == "ADMIN_" && `text-error`} message="role.admin" />
                            <Switch checked={viewAs == "USER_"} onCheckedChange={(e) => { handleSetViewAs(); setOpen(false) }} />
                            <Label fontWeight={viewAs == "USER_" && `bold`} className={viewAs == "USER_" && `text-secondary`} message="role.consultant" />
                        </div>
                    </div>
                }
                <Translate className="w-full" />
                <Button style="outline" text="global.actions.logout" className="w-full" onClick={() => navigate("/logout")} />
            </PopoverContent>
        </Popover>
    )
};

//TODO : quand un fait navigate("./url") on doit etre redirigé à racine/url et si on fait navigate("url")
// on doit etre redirigé à racine/actuel/url, actuellement c'est l'inverse.
